import { Spinner, SpinnerSize } from '@fluentui/react';
import { useEffect } from 'react';
import localeService from 'src/dataServices/LocaleService';

interface IHomeRedirectProps {
  locale: string;
  pathname: string;
}

export const HomeRedirect = (props: IHomeRedirectProps) => {
  useEffect(() => {
    // Strip any existing locale segment from the pathname to avoid double-locale URLs
    const pathWithoutLocale = props.pathname.replace(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/i, '');
    // Preserve the original query string and hash
    const search = window.location.search;
    const hash = window.location.hash;
    window.location.replace(`/${props.locale.toLowerCase()}${pathWithoutLocale}${search}${hash}`);
  }, [props.locale, props.pathname]);

  if (document) {
    const header = document.getElementById('header-panel');
    const footer = document.getElementById('nonprofit-footer');

    if (header) {
      header.hidden = true;
    }

    if (footer) {
      footer.hidden = true;
    }
  }

  return (
    <Spinner
      size={SpinnerSize.large}
      label={localeService.getText('Shared', 'SpinnerPleaseWait')}
      ariaLive="assertive"
    />
  );
};

export default HomeRedirect;
